import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React from "react";

const RatingScaleQuestion = observer(({question, index}) => {
    const {generalStore} = useStores();

    return (
        <>
            <div className="py-2 text-xs">{generalStore.translate('selectARating')}:</div>
            <div className="flex flex-row justify-between items-center gap-2">
                {[...Array(5).keys()].map(i => (
                    <div
                        key={i}
                        style={{ flex: '1 1 0' }}
                        onClick={() =>{ question.RatingValue = i+1}}
                        className={`h-11 rounded-xl outline outline-1 outline-panels-normal outline-offset-[-1px] flex items-center justify-center cursor-pointer ${(question.RatingValue && question.RatingValue === i+1) ?'bg-classic-button-normal text-classic-button-normal-text':'hover:bg-background-hover'}`}
                    >
                      <span className="text-sm font-normal leading-5 text-center font-sans">
                        {i + 1}
                      </span>
                    </div>
                ))}
            </div>

            <div className="flex flex-row justify-between w-full"
                 style={{fontSize: 12, color: 'var(--disabledunselected-normal-color)'}}>
                <div>{generalStore.translate('Lowest')}</div>
                <div>{generalStore.translate('Highest')}</div>
            </div>
        </>
    );
});

export default RatingScaleQuestion;
